import React, { useEffect, useRef, useState } from "react";
import "./let.css";

const YT_PLAYLIST_ID = "PLrioL8HG91KlGblJ31rTCzs8BfqIBU0s9";

export default function Let() {

  return (
    <div className="cv-root">
      <AnimatedBackground />
      <FloatingConfetti />

      <main className="cv-container">
        <header className="cv-header">
          <div className="cv-badge">
            <IconHeart/>
            <span>Meu convite especial para você</span>
          </div>
        </header>

        <section className="cv-card cv-animate-in">
          <h1 className="cv-title">Jantar a Dois</h1>
          <p className="cv-subtitle">
            Um encontro só nosso — leve, tranquilo e com a nossa vibe.
          </p>

          <div className="cv-info">
            <InfoRow icon={<IconCalendar size={14} />}>Quarta, 05 de novembro — 19:00</InfoRow>
            <InfoRow icon={<IconPin size={14} />}>Casa do Lucas (Mesa reservada)</InfoRow>
          </div>

          <div className="cv-quote">
            <p>
              "Quero te propor um momento que seja só nosso: olhar nos seus olhos,
              rir e se aproximar, deixar a noite dançar no nosso ritmo."
            </p>
          </div>

          <div className="cv-cta">
            <a
              className="cv-btn-primary"
              href="https://wa.me/5519983839419?text=Sim!+Aceito+o+convite+para+o+nosso+jantar!"
              target="_blank"
              rel="noreferrer"
            >
              Quero ir!
            </a>
          </div>
        </section>

        <section id="playlist" className="cv-player-section">
          <h2 className="cv-h2">Nossa trilha sonora</h2>
          <div className="cv-player-wrap">
            <PlaylistPlayer playlistId={YT_PLAYLIST_ID} />
          </div>
        </section>

        <footer className="cv-footer">Feito com carinho para você ❤️</footer>
      </main>
    </div>
  );
}

function InfoRow({ icon, children }) {
  return (
    <div className="cv-inforow">
      <span className="cv-inforow-icon">{icon}</span>
      <span className="cv-inforow-text">{children}</span>
    </div>
  );
}

// ---------------- YouTube IFrame API ----------------
function useYouTubeAPI() {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.YT && window.YT.Player) {
      setReady(true);
      return;
    }
    const existing = document.getElementById("yt-iframe-api");
    if (existing) {
      window.onYouTubeIframeAPIReady = () => setReady(true);
      return;
    }
    const tag = document.createElement("script");
    tag.id = "yt-iframe-api";
    tag.src = "https://www.youtube.com/iframe_api";
    window.onYouTubeIframeAPIReady = () => setReady(true);
    document.body.appendChild(tag);
  }, []);
  return ready;
}

function PlaylistPlayer({ playlistId }) {
  const apiReady = useYouTubeAPI();
  const containerRef = useRef(null);
  const playerRef = useRef(null);
  const [needsUnmute, setNeedsUnmute] = useState(true);

  useEffect(() => {
    if (!apiReady || !containerRef.current || playerRef.current) return;
    try {
      playerRef.current = new window.YT.Player(containerRef.current, {
        height: "100%",
        width: "100%",
        playerVars: {
          listType: "playlist",
          list: playlistId,
          autoplay: 1,
          mute: 1, // iOS exige gesto do usuário para tocar com som
          playsinline: 1,
          rel: 0,
          controls: 1,
          modestbranding: 1,
          iv_load_policy: 3,
          loop: 1,
        },
        events: {
          onReady: (event) => {
            try {
              event.target.mute();
              event.target.playVideo();
            } catch {}
          },
        },
      });
    } catch (_) {}
  }, [apiReady, playlistId]);

  const handleUnmute = () => {
    try {
      if (playerRef.current) {
        playerRef.current.unMute();
        playerRef.current.setVolume(85);
        setNeedsUnmute(false);
      }
    } catch (_) {}
  };

  return (
    <div className="cv-player">
      <div ref={containerRef} className="cv-player-iframe" />
      {needsUnmute && (
        <div className="cv-unmute">
          <button className="cv-btn-primary" onClick={handleUnmute}>Ativar som</button>
        </div>
      )}
    </div>
  );
}

// ---------------- Ícones (SVG inline, sem libs) ----------------
function IconHeart({ size = 20 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      style={{ display: "block" }}
    >
      <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 6 4 4 6.5 4c1.74 0 3.41 1.01 4.22 2.53C11.09 5.01 12.76 4 14.5 4 17 4 19 6 19 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
    </svg>
  );
}

function IconMusic({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <path d="M9 18a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm8-9.5V17a3 3 0 1 1-2-2.83V6.5l2-1v3z" fill="currentColor"/>
    </svg>
  );
}
function IconCalendar({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <path d="M7 2h2v2h6V2h2v2h3a2 2 0 0 1 2 2v13a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6a2 2 0 0 1 2-2h3V2zM4 9h16v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9z" fill="currentColor"/>
    </svg>
  );
}
function IconPin({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <path d="M12 2a7 7 0 0 0-7 7c0 5 7 13 7 13s7-8 7-13a7 7 0 0 0-7-7zm0 9.5A2.5 2.5 0 1 1 12 6a2.5 2.5 0 0 1 0 5.5z" fill="currentColor"/>
    </svg>
  );
}
function IconShare({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <path d="M18 8a3 3 0 1 0-2.83-4H15a3 3 0 0 0 .17 1L8.91 9.12A3 3 0 0 0 6 8a3 3 0 1 0 2.83 4H9a3 3 0 0 0-.17-1l6.25-4.12A3 3 0 0 0 18 8zm0 8a3 3 0 0 0-2.83 2H15a3 3 0 1 0 .17-1l-6.26-4.12A3 3 0 0 0 6 16a3 3 0 1 0 2.83-4H9a3 3 0 0 0-.17 1l6.26 4.12A3 3 0 0 0 18 16z" fill="currentColor"/>
    </svg>
  );
}

// ---------------- Fundo e partículas ----------------
function AnimatedBackground() {
  return (
    <div aria-hidden className="cv-bg">
      <div className="cv-bg-gradient" />
      <div className="cv-bg-glow cv-bg-glow-top" />
      <div className="cv-bg-glow cv-bg-glow-bottom" />
      <div className="cv-bg-vignette" />
    </div>
  );
}

function FloatingConfetti() {
  const items = Array.from({ length: 18 });
  const colors = [
    "#60A5FA", // azul
    "#A78BFA", // lilás
    "#FDE047", // amarelo
    "#34D399", // verde menta
    "#FB7185", // coral/rose
    "#22D3EE", // ciano
  ];
  return (
    <div aria-hidden className="cv-confetti-wrap">
      {items.map((_, i) => {
        const size = 8 + ((i * 7) % 16);
        const left = (i * 57) % 100;
        const delay = (i % 8) * 0.55;
        const shape = i % 3; // 0 círculo, 1 losango, 2 estrela
        const color = colors[i % colors.length];
        return (
          <span
            key={i}
            className={`cv-confetti s${shape}`}
            style={{
              left: `${left}%`,
              bottom: `${(i * 11) % 60}%`,
              width: size,
              height: size,
              backgroundColor: shape === 0 ? color : "transparent",
              borderColor: color,
              color,
              animationDelay: `${delay}s`,
            }}
          >
            {shape === 2 ? "✦" : ""}
          </span>
        );
      })}
    </div>
  );
}

function FloatingHearts() {
  const hearts = Array.from({ length: 12 });
  return (
    <div aria-hidden className="cv-hearts">
      {hearts.map((_, i) => (
        <span key={i} className="cv-heart" style={{
          left: `${(i * 83) % 100}%`,
          bottom: `${(i * 9) % 50}%`,
          animationDelay: `${(i % 6) * 0.8}s`,
          fontSize: `${10 + ((i * 7) % 18)}px`,
        }}>❤</span>
      ))}
    </div>
  );
}